/**
 * Centralized Claude model identifiers.
 *
 * The 13-file `'claude-sonnet-4-5-20250929'` hardcode (since-deprecated) silently
 * 400'd every AI feature in the app for ~weeks before anyone noticed — the
 * ai-briefing circuit breaker tripped on first call and stayed tripped for the
 * session. Pinning the model ID in one place stops that from recurring.
 *
 * When Anthropic ships a new family, update these three constants and every
 * caller migrates at once. Do NOT inline a model string in service code.
 */

/** Workhorse model for briefings, summaries, scope matching, BOM parsing, etc. */
export const CLAUDE_MODEL_SONNET = 'claude-sonnet-4-6';

/** Lightweight model for inline classification / suggestions / batch tagging. */
export const CLAUDE_MODEL_HAIKU = 'claude-haiku-4-5-20251001';

/** High-reasoning model — used by the on-demand job-insights "What should I
 *  know?" pass (job-insights.service.ts). Bumped 4.7 → 4.8 (4.7 was stale and
 *  errored on first runtime use). Must stay in sync with the server copy +
 *  proxy allow-list in functions/src/ai/claude-client.ts. */
export const CLAUDE_MODEL_OPUS = 'claude-opus-4-8';
